import React, { useState, useCallback, useEffect } from "react";
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from "../style.module.scss"

import { Swiper, SwiperSlide } from 'swiper/react';

import RightToLeft from "../../../components/transitions/right-to-left"
import { BlackMask } from "../../../components/mask";
import BottomToTop from '../../../components/transitions/bottom-to-top'

import { useSelector, useDispatch } from "react-redux";
import ProductBestSellers from "./product-best-sellers";
import { FormattedMessage, useIntl } from "react-intl";
import useOpenWindow from '../../../hooks/open-window'
import useOpenSizeChart from "../../../hooks/open-sizechart";
import { QuickShippingTxt } from "./product-main-container/quick-shipping";

const ProductDetailMessage = props => {
    const { showDetailMessage, description, isDetailModal, onClose } = props;

    const getDescription = useCallback(desc => {
        try {
            return desc?.replace(/font-size:\s*\d*.?\d*rem/g, '')?.replace(/(<b[^>]*>.*?<font\s+[^>]*\bface=")tahoma(".*?<\/font>.*?<\/b>)/g, '$1Roboto-Medium$2').replace('tahoma', 'Roboto').replace(/(<[^>]+?style=".*?)font-size\s*:\s*[^;"']*;?(.*?)"/g, '$1$2"').replace(/<font[^>]*\ssize="[^"]*"/g, '<font')?.replace(/white-space: pre;/g, '')?.replace(/white-space:pre;/g, '')
        } catch (error) {
            return desc
        }
    }, [])

    return (
        <React.Fragment>
            <BottomToTop in={showDetailMessage} className={classes.DescriptionContainer}>
                <div>
                    {
                        isDetailModal ? (
                            <div className={classes.Hd}>
                                <span><FormattedMessage id="description" defaultMessage="Description" /></span>
                                <span className={`iconfont ${classes.Icon}`} onClick={onClose}>&#xe69a;</span>
                            </div>
                        ) : (
                            <div className={classes.BeautyHd}>
                                <p><FormattedMessage id="ingredients" defaultMessage="Ingredients" /></p>
                                <span className={`iconfont ${classes.Icon}`} onClick={onClose}>&#xe7c9;</span>
                            </div>
                        )
                    }

                    <div className={classes.Bd}>
                        {
                            description && <div className={!isDetailModal && classes.Font} dangerouslySetInnerHTML={{ __html: isDetailModal ? getDescription(description) : description }}></div>
                        }

                    </div>
                </div>
            </BottomToTop>

            {
                showDetailMessage && <BlackMask onClick={onClose} />
            }

        </React.Fragment>
    )
}


const ProductFeature = props => {
    const { show, description, onClose } = props;

    const getDescription = useCallback(desc => {
        return desc?.replace(/font-size:\s*\d*.?\d*rem/g, '')
    }, [])

    return (
        <React.Fragment>
            <BottomToTop in={show} className={classes.DescriptionContainer}>
                <div>
                    <div className={classes.Hd}>
                        <span><FormattedMessage id="item_features" defaultMessage="Product Features" /></span>
                        <span className={`iconfont ${classes.Icon}`} onClick={onClose}>&#xe69a;</span>
                    </div>

                    <div className={classes.Bd}>
                        {
                            description && <div dangerouslySetInnerHTML={{ __html: getDescription(description) }}></div>
                        }
                    </div>
                </div>
            </BottomToTop>
            {
                show && <BlackMask onClick={onClose} />
            }
        </React.Fragment>
    )
}

export const ShippingDetailFrameModule = (props) => {
    useStyles(classes)
    const { src, title, onClose, show } = props
    return (
        <React.Fragment>
            <RightToLeft in={show} className={classes.ProductDetailFrame}>
                <div>
                    <div className={classes.Hd}>
                        <span className={classes.Font}>{title}</span>
                        <span className={`iconfont ${classes.Icon}`} onClick={onClose}>&#xe693;</span>
                    </div>
                    {
                        src && <div className={classes.Bd}>
                            <iframe src={`${src}`} frameborder="0" seamless></iframe>
                        </div>
                    }
                </div>
            </RightToLeft>
        </React.Fragment>
    )
}

const ShippingInfoMessageSwiper = props => {
    useStyles(classes);
    const { shippingInfoItem } = props;

    return (
        <React.Fragment>
            {
                shippingInfoItem?.length > 0 && <Swiper
                    onSlideChange={() => {
                    }}
                    onSwiper={(swiper) => {
                    }}
                    spaceBetween={10}
                    slidesPerView='auto'
                >
                    {
                        shippingInfoItem.map((shipping, index) => <SwiperSlide key={index} className={classes.ShippingItem}>
                            {
                                shipping?.shippingMsg && <div>
                                    <span>{shipping.shippingMsg}</span>
                                </div>
                            }

                            {
                                shipping?.estimatedArrivalTime && <div style={{ marginTop: "10px" }}>
                                    <span><FormattedMessage id="estimated_time" defaultMessage="Estimated Time of Arrival" />:</span>
                                    <span>{shipping.estimatedArrivalTime}</span>
                                </div>
                            }
                        </SwiperSlide>)
                    }
                </Swiper>
            }

        </React.Fragment>

    )
}

const ProductModelStature = props => {
    useStyles(classes);
    const { modelStature } = props;

    return (
        <div className={classes.ModelStatureContainer}>
            <div className={classes.Hd}>
                <FormattedMessage id="model_stature" defaultMessage="Model Stature" />
            </div>

            <div className={classes.Bd}>
                {
                    modelStature?.image && <div>
                        <span className={classes.Icon} style={{ backgroundImage: `url(${modelStature.image})` }}></span>
                    </div>
                }

                <div className={classes.Message}>
                    {
                        modelStature?.wear && <div>
                            <span className={classes.MessageTitle}><FormattedMessage id="model_wear" defaultMessage="Model Wear" />: </span>
                            <span>{modelStature.wear}</span>
                        </div>
                    }

                    <div className={classes.MessageSize}>
                        {
                            modelStature?.height && <div>
                                <span className={classes.MessageTitle}><FormattedMessage id="height" defaultMessage="Height" />: </span>
                                <span>{modelStature.height}cm</span>
                            </div>
                        }

                        {
                            (modelStature?.bust || modelStature?.breast) && <div>
                                <span className={classes.MessageTitle}><FormattedMessage id="bust" defaultMessage="Bust" />: </span>
                                <span>{modelStature.bust || modelStature.breast}cm</span>
                            </div>
                        }

                        {
                            modelStature?.waist && <div>
                                <span className={classes.MessageTitle}><FormattedMessage id="waist" defaultMessage="Waist" />: </span>
                                <span>{modelStature.waist}cm</span>
                            </div>
                        }

                        {
                            modelStature?.hip && <div>
                                <span className={classes.MessageTitle}><FormattedMessage id="hips" defaultMessage="Hips" />: </span>
                                <span>{modelStature.hip}cm</span>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

const ProductShippingInfo = (props) => {
    useStyles(classes);
    const { productVO, isBeautyMakeup, selectedProduct, selectedVariant } = props;

    // const [showDetailMessage, setShowDetailMessage] = useState(false);

    const { sizeChart, setSizeChart } = useOpenSizeChart()
    const { show: showDetailMessage, setShow: setShowDetailMessage } = useOpenWindow('detail_message')
    const { show: showFeatures, setShow: setShowFeatures } = useOpenWindow('features_window')

    const [isDetailModal, setIsDetailModal] = useState(false);
    const [showSizeChart, setShowSizeChartLocal] = useState(false);

    const Intl = useIntl();

    const dispatch = useDispatch();

    const beautyColor = productVO?.isLogisticsInCountryIsNotSupported ? "#E64545" : "#3aaf43";

    useEffect(async () => {
        if (selectedProduct?.variants?.length > 1 && selectedProduct?.sizeChart2 && productVO?.taglia) {
            // let response = await getProductTaglia(selectedProduct?.id);
            // if(response?.result){
            setShowSizeChartLocal(true);
            // }
        }
    }, []);



    const changeModalProperites = (flag) => {
        setShowDetailMessage(true)
        setIsDetailModal(flag);
    }

    const changeFeatureModal = flag => {
        setShowFeatures(true)
    }

    // 是否为海外仓商品
    const isDisabled = selectedVariant?.domesticDelivery.enabled;
    const isOv = !!selectedProduct?.variants?.find(v => v?.domesticDelivery?.enabled)

    const shippingI18 = Intl.formatMessage(
        { id: 'us_address_deliverd' },
        { value: `<span style="font-family: Roboto-Medium;color:#222222;">${Intl.formatMessage({ id: 'us_address' })}</span>` }
    );

    const openSizeChart = () => {
        setSizeChart({
            show: true,
            data: {
                selectedProduct: selectedProduct,
                products: productVO?.products,
                taglia: productVO?.taglia,
                productSizeData: productVO?.productSizeData
            }
        })
        if (window.GeekoSensors) {
            window.GeekoSensors.Track('ELClick', {
                clicks: 'sizechart'
            })
        }
    }

    const { show: showReturn, setShow: setShowReturn } = useOpenWindow('return-policy')
    const { show: showShippingMethod, setShow: setShowShippingMethod } = useOpenWindow('shipping-method')

    const getDescription2 = useCallback(desc => {
        try {
            const r= desc?.replace(/font-size:\s*\d*.?\d*rem/g, '')?.replace(/(<b[^>]*>.*?<font\s+[^>]*\bface=")tahoma(".*?<\/font>.*?<\/b>)/g, '$1Roboto-Medium$2').replace('tahoma', 'Roboto').replace(/(<[^>]+?style=".*?)font-size\s*:\s*[^;"']*;?(.*?)"/g, '$1$2"').replace(/<font[^>]*\ssize="[^"]*"/g, '<font')?.replace(/white-space: pre;/g, '')?.replace(/white-space:pre;/g, '')?.replace(/<\/?(html|head|body)[^>]*>/gi, '') // 去掉<html>、<head>、<body>
            console.log(r)
            return r
            // return "2222"
        } catch (error) {
            return desc
        }
    }, [])
    return (
        <div className={`${classes.ShippingInfoContainer}`}>
            <div className={`${classes.ShippingInfo} ${classes.GolbalBorderTop}`}>
                <div className={classes.Hd}>
                    {productVO?.freeShippingTitle}
                </div>

                {
                    // 如果存在海外仓产品则提示 quick shipping
                    isDisabled && productVO?.domesticDeliveryShippingInfo?.description &&
                    <QuickShippingTxt clickHandle={() => setShowShippingMethod(true)} htmlValue={productVO?.domesticDeliveryShippingInfo?.description} />
                }

                <div className={`${classes.Bd}`}>
                    <div className={`${classes.MpPannelTitle} ${classes.MTable}`} style={{ borderBottom: "none" }} onClick={() => setShowShippingMethod(true)}>
                        <div className={`${classes.MTableCell} ${classes.MVerticalMiddle}`} style={{ width: "27px", verticalAlign: `${isDisabled ? 'top' : 'middle'}` }}>
                            <span className={`iconfont ${classes.ProductIcon}`} style={{ color: beautyColor, fontSize: 16 }}>&#xe765;</span>
                        </div>
                        <div className={`${classes.MTableCell} ${classes.MVerticalMiddle}`}>
                            {
                                isDisabled ? (
                                    productVO?.domesticDeliveryShippingInfo?.shippingInfoItems?.[0] && <>
                                        <p className={classes.ProductFontStyle2} dangerouslySetInnerHTML={{ __html: productVO?.domesticDeliveryShippingInfo?.shippingInfoItems[0].shippingMsg }}></p>

                                        {
                                            productVO?.domesticDeliveryShippingInfo?.shippingInfoItems?.[0]?.estimatedArrivalTime && <p style={{ marginTop: 5 }}><span className={classes.ProductFontStyle2}><span dangerouslySetInnerHTML={{ __html: shippingI18 }}></span></span> <span className={classes.ProductFontStyle3}>{productVO?.domesticDeliveryShippingInfo?.shippingInfoItems?.[0]?.estimatedArrivalTime}</span></p>
                                        }
                                    </>
                                ) : (
                                    productVO?.isLogisticsInCountryIsNotSupported ? <span style={{ color: beautyColor }}><FormattedMessage id="ship_current_address" defaultMessage="This item cannot ship to current address" /></span> : <span className={classes.ProductFontStyle}><FormattedMessage id="shipping_method" defaultMessage="Shipping Method" /></span>
                                )
                            }
                        </div>

                        <div className={`${classes.MTableCell} ${classes.MVerticalMiddle} ${classes.MTextAlignRight}`}>
                            <span className={`iconfont ${classes.ProductRightIcon}`}>&#xe694;</span>
                        </div>
                    </div>

                    {
                        !isDisabled && <div className={classes.ShippingItemContainer}>
                            <ShippingInfoMessageSwiper shippingInfoItem={productVO?.shippingInfo?.shippingInfoItems} />
                        </div>
                    }
                </div>

                {
                    productVO?.returnInfo && <div className={`${classes.Bd} ${classes.GlobalBorderTop1}`}>
                        <div className={`${classes.MpPannelTitle} ${classes.MTable}`} style={{ borderBottom: "none" }} onClick={() => setShowReturn(true)}>
                            <div className={`${classes.MTableCell} ${classes.MVerticalMiddle}`} style={{ width: "27px" }}>
                                <span className={`iconfont ${classes.ProductIcon}`} style={{ color: beautyColor, fontSize: 22 }}>&#xe6aa;</span>
                            </div>
                            <div className={`${classes.MTableCell} ${classes.MVerticalMiddle}`}>
                                {productVO.returnInfo?.title}
                            </div>

                            <div className={`${classes.MTableCell} ${classes.MVerticalMiddle} ${classes.MTextAlignRight}`}>
                                <span className={`iconfont ${classes.ProductRightIcon}`}>&#xe694;</span>
                            </div>
                        </div>

                        {
                            productVO.returnInfo?.message && <div className={classes.ReturnMessage}>
                                <span>{productVO.returnInfo.message}</span>
                            </div>
                        }
                    </div>
                }
            </div>

            {
                selectedProduct?.productCategoyProductRank && Object.keys(selectedProduct.productCategoyProductRank).length > 0 && selectedProduct?.productCategoryIds.length > 0 && <React.Fragment>
                    <ProductBestSellers
                        productRank={selectedProduct.productCategoyProductRank}
                        productCategoyName={selectedProduct.productCategoyProductRank?.productCategoyName}
                        productCategoryId={selectedProduct.productCategoryIds?.[0]}
                        selectedProduct={selectedProduct}
                    />
                </React.Fragment>
            }

            <div className={`${classes.GolbalBorderTop}`}>
                {
                    !isBeautyMakeup && selectedProduct?.modelStature?.imageModel && <ProductModelStature modelStature={selectedProduct.modelStature.imageModel} />
                }

                {
                    !isBeautyMakeup && showSizeChart && selectedProduct?.sizeChart2 && <div className={`${classes.MpPannelTitle} ${classes.MTable}`} onClick={() => openSizeChart()}>
                        <div className={`${classes.MTableCell} ${classes.MVerticalMiddle}`}>
                            <FormattedMessage id="sizing_help" defaultMessage="Sizing Help" />
                        </div>

                        <div className={`${classes.MTableCell} ${classes.MVerticalMiddle} ${classes.MTextAlignRight}`}>
                            <span className={`iconfont ${classes.ProductRightIcon}`}>&#xe694;</span>
                        </div>
                    </div>
                }

                {
                    selectedProduct?.itemFeatures && <div className={`${classes.MpPannelTitle} ${classes.MTable}`} onClick={() => changeFeatureModal(true)}>
                        <div className={`${classes.MTableCell} ${classes.MVerticalMiddle}`}>
                            <FormattedMessage id="Item Features" defaultMessage="Product Features" />
                        </div>

                        <div className={`${classes.MTableCell} ${classes.MVerticalMiddle} ${classes.MTextAlignRight}`}>

                        </div>
                        <div className={`${classes.MTableCell} ${classes.MVerticalMiddle} ${classes.MTextAlignRight}`}>
                            <span className={`iconfont ${classes.ProductRightIcon}`} style={{ display: "inline-block", transform: "scale(0.3)", width: "29px" }}>&#xe6f3;</span>
                        </div>
                    </div>
                }

                <div className={`${classes.MpPannelTitle} ${classes.MTable}`} style={{ borderBottom: "none" }} >
                    <div className={`${classes.MTableCell} ${classes.MVerticalMiddle}`}>
                        <FormattedMessage id="product_details" defaultMessage="Product Details" />
                        {
                           selectedProduct?.description2 && <div className={!isDetailModal && classes.Font} dangerouslySetInnerHTML={{ __html: getDescription2(selectedProduct?.description2) }}></div>
                        }
                    </div>

                    <div className={`${classes.MTableCell} ${classes.MVerticalMiddle} ${classes.MTextAlignRight}`}>
                        {
                            selectedProduct?.descriptionModel && <React.Fragment>
                                {
                                    selectedProduct?.descriptionModel?.material && <span style={{ fontSize: "14px", color: "#666666", marginRight: "6px" }}>#{selectedProduct?.descriptionModel?.material}</span>
                                }

                                {
                                    selectedProduct?.descriptionModel?.fitType && <span style={{ fontSize: "14px", color: "#666666", marginRight: "6px" }}>#{selectedProduct?.descriptionModel?.fitType}</span>
                                }
                            </React.Fragment>
                        }
                    </div>

                    {/*<div className={`${classes.MTableCell} ${classes.MVerticalMiddle} ${classes.MTextAlignRight}`}>*/}
                    {/*    <span className={`iconfont ${classes.ProductRightIcon}`} style={{ display: "inline-block", transform: "scale(0.3)", width: "29px" }}>&#xe6f3;</span>*/}
                    {/*</div>*/}
                </div>








                {
                    isBeautyMakeup && <div className={`${classes.MpPannelTitle} ${classes.MTable}`} onClick={() => changeModalProperites(false)}>
                        <div className={`${classes.MTableCell} ${classes.MVerticalMiddle}`}>
                            <FormattedMessage id="ingredients" defaultMessage="Ingredients" />
                        </div>

                        <div className={`${classes.MTableCell} ${classes.MVerticalMiddle} ${classes.MTextAlignRight}`}>
                            <span className={`iconfont ${classes.ProductRightIcon}`}>&#xe694;</span>
                        </div>
                    </div>
                }
            </div>


            <ShippingDetailFrameModule show={showShippingMethod} onClose={() => setShowShippingMethod(false)} title={Intl.formatMessage({ id: 'shipping_information', defaultMessage: "Shipping Information" })} src={`/policy/shipping-policy?productId=${selectedProduct?.id}&isApp=1`} />
            <ShippingDetailFrameModule show={showReturn} onClose={() => setShowReturn(false)} title={Intl.formatMessage({ id: 'return_policy', defaultMessage: "Return Policy" })} src="/policy/return-policy?isApp=1" />

            <ProductDetailMessage
                isDetailModal={isDetailModal}
                showDetailMessage={showDetailMessage}
                description={isDetailModal ? selectedProduct?.description2 : selectedProduct?.beautyIngredients}
                onClose={() => setShowDetailMessage(false)}
            />

            <ProductFeature
                show={showFeatures}
                description={selectedProduct?.itemFeatures}
                onClose={() => setShowFeatures(false)}
            />
        </div>
    )
}

export default ProductShippingInfo;